module.exports = __webpack_public_path__ + "static/cloudPricing-metaImg_TC-1c1c080913a776705788682f7bd4d26b.png";